<template>
  <v-card class="review-decline">
    <v-subheader>
      <v-icon medium color="error" class="mr-2">people</v-icon>
      {{date}} <span class="ml-2">Отменено участие в ревью уровня {{level}}</span>
    </v-subheader>
  </v-card>
</template>

<script>
  export default {
    name: "ReviewDecline",
    props: ["date", "description", "level"]
  }
</script>

<style scoped>
  .review-decline {
    border: 1px solid #78909C;
  }

</style>